import { render } from "./advisorInfo.vue?vue&type=template&id=0a40d72e&ts=true"
import script from "./advisorInfo.vue?vue&type=script&lang=ts"
export * from "./advisorInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__